import moment from 'moment';
import format from 'date-fns/format';
import { QuestionTextField, QuestionJurisdictionDropDownField, QuestionDateDropdownField, QuestionYesNoField } from 'components/Questionnaires/fields';
import { QuestionAddressBlock, QuestionTaxResidenceBlock, QuestionBlockRepeater, QuestionSignerBlock, QuestionUsTinBlock } from 'components/Questionnaires/blocks';
import { requiredValidator } from 'components/Questionnaires/validators';

const fatcaCrsI = {
  blocks: [
    {
      id: 'name',
      title: 'questionnaire.crs.name',
      component: undefined, // Component for Block
      info: {
        instructions: 'questionnaire.crs.name.firstName.info'
      },
      visible: true,
      questions: [
        {
          id: 'firstName',
          label: 'questionnaire.crs.name.firstName.label',
          component: QuestionTextField,
          className: 'col-12 col-lg-6',
          visible: true,
          lockGroup: 'name',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.name.firstName.errorMessage' }
            ]
          }
        },
        {
          id: 'middleName',
          label: 'questionnaire.crs.name.middleName.label',
          component: QuestionTextField,
          className: 'col-12 col-lg-6',
          visible: true,
          lockGroup: 'name',
        },
        {
          id: 'lastName',
          label: 'questionnaire.crs.name.lastName.label',
          component: QuestionTextField,
          className: 'col-12',
          visible: true,
          lockGroup: 'name',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.name.lastName.errorMessage' }
            ]
          }
        },
      ],
    },
    {
      id: 'businessName',
      title: 'questionnaire.fatcacrs.i.businessName',
      component: undefined, // Component for Block
      visible: true,
      questions: [
        {
          id: 'name',
          label: 'questionnaire.fatcacrs.i.businessName.name.label',
          component: QuestionTextField,
          visible: true,
        },
      ]
    },
    {
      id: 'address',
      title: 'questionnaire.address',
      component: QuestionAddressBlock,
      componentProps: {
        line1Label: 'questionnaire.address.1.label',
      },
      info: {
        instructions: 'questionnaire.address.1.info'
      },
      visible: true,
      lockGroup: 'permanentAddress',
    },
    {
      id: 'mailingAddress',
      title: 'questionnaire.mailingAddress',
      component: QuestionAddressBlock,
      componentProps: {
        line1Label: 'questionnaire.mailingAddress.1.label',
        optional: true
      },
      info: {
        instructions: 'questionnaire.mailingAddress.1.info'
      },
      visible: true,
      linkBlock: true,
      lockGroup: 'mailingAddress',
    },
    {
      id: 'usDetermination',
      title: 'questionnaire.fatcacrs.usDetermination',
      info: {
        instructions: 'questionnaire.fatcacrs.usDetermination.info'
      },
      questions: [
        {
          id: 'isUsPerson',
          label: 'questionnaire.fatcacrs.usDetermination.label',
          component: QuestionYesNoField,
          visible: true,
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.fatcacrs.usDetermination.errorMessage' }
            ]
          }
        }
      ],
      visible: true
    },
    {
      id: 'usTin',
      title: 'questionnaire.usTin',
      component: QuestionUsTinBlock,
      componentProps: {
        showAppliedFor: false
      },
      info: {
        footnote: 'questionnaire.usTin.footnote'
      },
      visible: (qAnswers, preQualAnswers) => qAnswers?.usDetermination?.isUsPerson === 'Yes'
    },
    {
      id: 'taxResidences',
      title: 'questionnaire.taxResidences',
      component: QuestionBlockRepeater,
      componentProps: {
        collapsible: true
      },
      repeatBlock: {
        id: 'taxResidence',
        title: 'questionnaire.taxResidence',
        component: QuestionTaxResidenceBlock,
      },
      minSize: 1,
      maxSize: 5,
      addText: 'questionnaire.taxResidences.addLabel',
      visible: true,
    },
    {
      id: 'birth',
      title: 'questionnaire.birth',
      component: undefined, // Component for Block
      visible: true,
      questions: [
        {
          id: 'date',
          label: 'questionnaire.birth.date.label',
          component: QuestionDateDropdownField,
          componentProps: {
            minDate: format(moment().subtract(125, 'years').toDate(), 'dd-MM-yyyy'),
            maxDate: format(moment().subtract(1, 'days').toDate(), 'dd-MM-yyyy'),
            dateFormat: 'dd-MM-yyyy',
            showToolTip: true
          },
          info: {
            instructions: 'questionnaire.birth.date.info'
          },
          visible: true,
          lockGroup: 'dateOfBirth',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.birth.date.errorMessage' }
            ]
          }
        },
        {
          id: 'town',
          label: 'questionnaire.birth.town.label',
          component: QuestionTextField,
          className: 'col-12 col-lg-5',
          visible: true,
          lockGroup: 'cityOfBirth',
        },
        {
          id: 'country',
          label: 'questionnaire.birth.country.label',
          component: QuestionJurisdictionDropDownField,
          className: 'col-12 col-lg-7',
          visible: true,
          lockGroup: 'countryOfBirth',
        },
      ]
    },
    {
      id: 'signer',
      title: 'questionnaire.signer',
      component: QuestionSignerBlock,
      componentProps: {
        individualOnly: true
      },
      visible: true
    },
  ]
};

export default fatcaCrsI;
